import { Injectable, NgZone } from '@angular/core';

import { Subject } from 'rxjs';
import { AuthService } from '../../core/auth/auth-service';
import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from '@apollo/client/link/http';
import gql from 'graphql-tag';
import { createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { environment } from '../../../environments/environment';
const ON_NOTIFICATION = `
subscription OnNotification($actorUserId: String!) {
  onNotification(actorUserId: $actorUserId) {
    requestorUserId
    actorUserId
    message
    notificationType
    requestId
    action
    status
    timestamp
    requestName
    requestEmail
    flightNumber
    carrierCode
    flightSuffix
    origin
    commodityGroupCode
    flightDateTime
  }
}
`;
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private sub: any;
  private userId?: string;
  
  notification$ = new Subject<any>();
  private healthCheckTimer: any;
  private reconnectTimer: any;
  private connecting = false;
  private lastMessageTime = Date.now();
  constructor(private readonly auth: AuthService, private readonly ngZone: NgZone) {
    window.addEventListener('focus', () => {
      if (!this.sub && !this.connecting) {
        void this.start();
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && !this.sub && !this.connecting) {
        void this.start();
      }
    });
    window.addEventListener('online', () => {
      if (!this.sub && !this.connecting) {
        void this.start();
      }
    });
    if (typeof jasmine === 'undefined') {
      this.startHealthCheck();
    }
  }

  async start() {
    if (this.sub || this.connecting) {
      return;
    }

    this.userId = this.auth.getUserNid();

    if (!this.userId) {
      return;
    }
    this.userId = this.userId.toUpperCase();

    void this.connect();
  }
  private scheduleReconnect(delay = 100) {
    clearTimeout(this.reconnectTimer);

    this.reconnectTimer = setTimeout(() => {
      this.sub = undefined;

      void this.connect();
    }, delay);
  }
  private async connect() {
    if (this.connecting) {
      return;
    }

    this.connecting = true;
    try {
      this.sub?.unsubscribe();

      const token = await this.auth.getToken();

      if (!token) {
        this.sub = undefined;

        this.scheduleReconnect(100);

        return;
      }
      const normalizedUserId = this.userId?.toUpperCase();
      const parts = token.split('.');
      if (parts.length !== 3) {
        this.scheduleReconnect(100);

        return;
      }

      const url = environment.appSync.endpoint;
      const region = environment.appSync.region;
      const auth = {
        type: 'OPENID_CONNECT' as const,
        jwtToken: token,
      };

      const httpLink = new HttpLink({ uri: url });

      const link = createSubscriptionHandshakeLink(
        { url, region, auth },
        createAuthLink({ url, region, auth }).concat(httpLink)
      );

      const client = new ApolloClient({
        link,
        cache: new InMemoryCache(),
      });
      this.lastMessageTime = Date.now();
      this.sub = client
        .subscribe({
          query: gql`
            ${ON_NOTIFICATION}
          `,
          variables: { actorUserId: normalizedUserId },
        })
        .subscribe({
          next: (res: any) => {
            this.lastMessageTime = Date.now();
            const data = res?.data?.onNotification;
            console.log('SERVICE RECEIVED', data);
            if (data) {
              this.ngZone.run(() => {
                this.notification$.next(data);
              });
            }
            
           
          },
          error: (err: any) => {
            const isAuthError = err?.errors?.some((e: any) => e.errorType === 'Unauthorized');
            if (isAuthError) {
              this.sub = undefined;

              this.scheduleReconnect(100);

              return;
            }

            this.scheduleReconnect(100);
          },
        });
    } catch (err) {
      console.error('Failed to establish notification subscription:', err);
      this.sub = undefined;

      this.scheduleReconnect(100);
    } finally {
      this.connecting = false;
    }
  }
  private startHealthCheck() {
    clearInterval(this.healthCheckTimer);

    this.healthCheckTimer = setInterval(() => {
      if (!this.sub && !this.connecting) {
       void this.start();
      }
    }, 30000);
  }

  stop(): void {
    clearTimeout(this.reconnectTimer);
    clearInterval(this.healthCheckTimer);
  
    if (this.sub?.unsubscribe) {
      this.sub.unsubscribe();
    }
  
    this.sub = undefined;
    this.connecting = false;
  
   
  }
}
